/** API/MySQL date → yyyy-MM-dd for input type="date" (local calendar day). */
export function formatDateForInput(value) {
  if (value == null || value === '') return '';
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m) return m[1];
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${mo}-${day}`;
}

function parseIsoDate(iso) {
  if (!iso) return null;
  const s = String(iso).trim().slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const year = Number(m[1]);
  const month = Number(m[2]) - 1;
  const day = Number(m[3]);
  const d = new Date(year, month, day);
  if (d.getFullYear() !== year || d.getMonth() !== month || d.getDate() !== day) return null;
  return d;
}

function formatIsoDate(date) {
  if (!date || Number.isNaN(date.getTime())) return null;
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${y}-${mo}-${day}`;
}

/** Next BWOF due from anniversary month/day relative to today (or refDate). */
export function computeNextBwofDueFromAnniversary(anniversaryIso, refDate = new Date()) {
  const anchor = parseIsoDate(anniversaryIso);
  if (!anchor) return '';

  const today = new Date(refDate);
  today.setHours(0, 0, 0, 0);
  const month = anchor.getMonth();
  const day = anchor.getDate();

  let candidate = new Date(today.getFullYear(), month, day);
  if (Number.isNaN(candidate.getTime())) return '';
  if (candidate < today) {
    candidate = new Date(today.getFullYear() + 1, month, day);
  }
  return formatIsoDate(candidate) || '';
}

/**
 * Anniversary = CS issue date. Due = explicit value or next month/day occurrence from anniversary.
 */
export function normalizeBuildingDatesForSave(anniversary, dueDate, { autoComputeDue = true } = {}) {
  const clean = (v) => {
    if (v === undefined || v === null) return '';
    const s = String(v).trim();
    if (!s) return '';
    return s.slice(0, 10);
  };

  const a = clean(anniversary);
  const d = clean(dueDate);

  if (a && d) {
    return { compliance_schedule_anniversary: a, due_date: d };
  }
  if (a && !d) {
    return {
      compliance_schedule_anniversary: a,
      due_date: autoComputeDue ? computeNextBwofDueFromAnniversary(a) : '',
    };
  }
  if (!a && d) {
    return { compliance_schedule_anniversary: null, due_date: d };
  }
  return { compliance_schedule_anniversary: null, due_date: null };
}
